import { render, staticRenderFns } from "./LinkSellersDialog.vue?vue&type=template&id=2ec63b19"
import script from "./LinkSellersDialog.vue?vue&type=script&lang=js"
export * from "./LinkSellersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports